/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class ShareableLink implements Serializable<ShareableLink> {
    shareableLink: string;

    deserialize(input: any) {
        input.shareableLink && (this.shareableLink = input.shareableLink);

        return this;
    }

    constructor() {
    }
}
